import React, { useState } from "react";
import { db, auth, doc, updateDoc, getDoc, setDoc } from "../firebase";
import NavbarDashboard from "../components/Navbar/NavbarDashboard";
import "../styles/style.css"
import { useEffect } from "react";
import AlreadyTaken from "../components/taken/already_taken";

const questions = {
  fundamentals: [
    {
      question:
        "According to the law, you are not allowed to drive fast, except when",
      options: [
        "Speed is in accordance with the given speed limit",
        "There is no danger in the road",
        "All answers are correct",
      ],
      correctAnswer: "All answers are correct",
    },
    {
      question:
        "The necessary distance in between you and a vehicle you are following should be:",
      options: [
        "The same length as two full vehicles",
        "The same length as a full vehicle",
        "The same length as three full vehicles",
      ],
      correctAnswer: "The same length as a full vehicle",
    },
    {
      question: "The vehicle horn is used for:",
      options: [
        "Making beautiful sounds",
        "Giving warning to avoid accident",
        "Creating noise",
      ],
      correctAnswer: "Giving warning to avoid accident",
    },
    {
      question:
        "What should you do to combat fatigue and sleepiness during long road trip?",
      options: [
        "Drink medicine that prevents sleepiness",
        "Stop every once in a while and rest",
        "Drink alcohol before driving",
      ],
      correctAnswer: "Stop every once in a while and rest",
    },
    {
      question: "What should you do if a policeman stops you?",
      options: [
        "Stop and argue with the policeman",
        "Don’t mind the cop and drive faster",
        "Stop and give the license and other papers for the vehicle if the policeman asks for it",
      ],
      correctAnswer:
        "Stop and give the license and other papers for the vehicle if the policeman asks for it",
    },
  ],
  traffic: [
    {
      question: "You can overtake in a highway if it has two lanes with",
      options: [
        "Broken yellow line",
        "Continuous white line",
        "Continuous yellow line",
      ],
      correctAnswer: "Broken yellow line",
    },
    {
      question: "What is the meaning of blinking yellow traffic light?",
      options: [
        "Wait for the green light",
        "Stop and wait for the traffic light to change",
        "Slow down and proceed if there is no danger",
      ],
      correctAnswer: "Slow down and proceed if there is no danger",
    },
    {
      question: "What is the meaning of green arrow traffic light?",
      options: [
        "It is prohibited to enter on the direction of the arrow",
        "Pedestrians can cross",
        "Allowing vehicles to go right or left",
      ],
      correctAnswer: "Allowing vehicles to go right or left",
    },
    {
      question:
        "What is the meaning of a circle, octagon or inverted triangle traffic sign with red border color?",
      options: ["Regulatory sign", "Warning sign", "Giving direction"],
      correctAnswer: "Regulatory sign",
    },
    {
      question:
        "What is the meaning of a triangle traffic sign with red border color?",
      options: ["Information sign", "Warning sign", "Reminder sign"],
      correctAnswer: "Warning sign",
    },
  ],
  safety: [
    {
      question: "You can overtake in the right side of your vehicle if:",
      options: [
        "The sidewalk is wide",
        "The road is two-way",
        "The road has two or more lanes going in one direction",
      ],
      correctAnswer: "The road has two or more lanes going in one direction",
    },
    {
      question: "It is more dangerous to turn left than to turn right because:",
      options: [
        "The road has more lanes",
        "You have to be aware and cautious from vehicles coming from left or right sides of the road",
        "Vehicles coming from left is faster",
      ],
      correctAnswer:
        "You have to be aware and cautious from vehicles coming from left or right sides of the road",
    },
    {
      question: "In a roundabout (rotunda), which has road rights?",
      options: [
        "The vehicles approaching the roundabout",
        "The vehicles in the roundabout",
        "The vehicles facing the green light",
      ],
      correctAnswer: "The vehicles in the roundabout",
    },
    {
      question: "If you are approaching a curve, what should you do?",
      options: ["Abruptly push the brake", "Speed up", "Slow down"],
      correctAnswer: "Slow down",
    },
    {
      question:
        "If the driver of a vehicle in front of you is giving a hand signal by pointing his left hand upwards, he will surely:",
      options: ["Turn left", "Turn right", "Stop"],
      correctAnswer: "Turn right",
    },
  ],
  fines: [
    {
      question:
        "A person who drives while under influence of alcohol or drugs is punishable by law with:",
      options: [
        "Suspension of license",
        "Fines and imprisonment",
        "All answers are correct",
      ],
      correctAnswer: "All answers are correct",
    },
    {
      question: "Not following road and traffic rules:",
      options: [
        "Saves fuel",
        "May engage you in an accident",
        "Proves that you are a good driver",
      ],
      correctAnswer: "May engage you in an accident",
    },
    {
      question: "Driving with a fake license is prohibited and punishable by:",
      options: [
        "Php 300.00",
        "Not more than six months imprisonment",
        "Php 1,500.00 and six months suspension in obtaining a license",
      ],
      correctAnswer:
        "Php 1,500.00 and six months suspension in obtaining a license",
    },
    {
      question:
        "If you are caught due to a violation, how many days are given for you to settle your case and get your license back?",
      options: ["30 days", "15 days", "10 days"],
      correctAnswer: "15 days",
    },
    {
      question: "What should you bring before driving a vehicle?",
      options: [
        "Driver’s license, vehicle registration, and receipt of last LTO payment for the vehicle",
        "Driver’s license",
        "Driver’s license and vehicle insurance paper",
      ],
      correctAnswer:
        "Driver’s license, vehicle registration, and receipt of last LTO payment for the vehicle",
    },
  ],
};

const PosttestModal = () => {
  const [posttestStatus, setPosttestStatus] = useState(false);

  useEffect(() => {
    const fetchPosttestStatus = async () => {
      const user = auth.currentUser;

      if (user) {
        const userId = user.uid;
        const userDocRef = doc(db, "users", userId);
        const statusDocRef = doc(userDocRef, "posttest", "status");

        try {
          const statusDoc = await getDoc(statusDocRef);
          if (statusDoc.exists()) {
            const { posttestStatus } = statusDoc.data();
            setPosttestStatus(posttestStatus);
          }
        } catch (error) {
          console.error("Error fetching posttest status:", error);
        }
      }
    };

    fetchPosttestStatus();
  }, []);

  return (
    <div className="already_taken_wrapper">
      {posttestStatus ? (
        <AlreadyTaken />
      ) : (
        <PostTestModalContent />
      )}
    </div>
  );
};

const PostTestModalContent = () => {
  const [currentTopic, setCurrentTopic] = useState("fundamentals");
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [scores, setScores] = useState({
    fundamentals: 0,
    traffic: 0,
    safety: 0,
    fines: 0,
  });
  const [quizCompleted, setQuizCompleted] = useState(false);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  const handleAnswerClick = (e) => {
    e.preventDefault();

    if (!selectedOption) {
      alert("Please select an option before moving to the next question.");
      return;
    }

    if (
      selectedOption === questions[currentTopic][currentQuestion].correctAnswer
    ) {
      setScores((prevScores) => ({
        ...prevScores,
        [currentTopic]: prevScores[currentTopic] + 1,
      }));
    }

    // Move to the next question in the current topic
    if (currentQuestion < questions[currentTopic].length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setSelectedOption(null);
    } else {
      // Switch to the next topic or end the quiz if there are no more topics
      const topicKeys = Object.keys(questions);
      const nextTopicIndex = topicKeys.indexOf(currentTopic) + 1;
      if (nextTopicIndex < topicKeys.length) {
        setCurrentTopic(topicKeys[nextTopicIndex]);
        setCurrentQuestion(0);
      } else {
        setQuizCompleted(true);
        // Send results to Firebase here
        sendResultsToFirebase();
      }
    }
  };

  // Calculate overall score
  const overallScore = Object.values(scores).reduce(
    (total, score) => total + score,
    0
  );
  const totalQuestions = Object.values(questions).flat().length;
  const overallPercentage = ((overallScore / totalQuestions) * 100).toFixed(2);

  const sendResultsToFirebase = async () => {
    const user = auth.currentUser;

    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId);

      // Create a status collection with posttestStatus set to true
      const statusDocRef = doc(userDocRef, "posttest", "status");
      await setDoc(statusDocRef, { posttestStatus: true });

      // Save overall score, number score, and percentage in the "posttest" collection
      const overallDocRef = doc(userDocRef, "posttest", "overall");
      await setDoc(overallDocRef, {
        overallScore,
        totalQuestions,
        overallPercentage,
      });

      // Loop through topics and save scores within the "posttest" collection
      Object.keys(scores).forEach(async (topic) => {
        const score = scores[topic];
        const accuracy = ((score / questions[topic].length) * 100).toFixed(2);

        // Create a document for each topic within the "posttest" collection
        const topicDocRef = doc(userDocRef, "posttest", topic);
        await setDoc(topicDocRef, {
          correctAnswers: score,
          totalQuestions: questions[topic].length,
          accuracy,
        });
      });
    } else {
      console.error("No user is currently logged in");
      // Handle the case where no user is logged in
    }
  };
  return (
    <div className="container-dashboard">
    <NavbarDashboard />
      <div className="pretest_wrapper">
        <h1>POST-TEST ASSESSMENT</h1>
        {!quizCompleted && currentQuestion < questions[currentTopic].length && (
          <div className="question_wrapper">
            <div className="question_wrapper_inner">
              <h3>QUESTION:</h3>
              <h3>{questions[currentTopic][currentQuestion].question}</h3>
            </div>
            <form className="question_form">
              {questions[currentTopic][currentQuestion].options.map(
                (option, index) => (
                  <div key={index}>
                    <input
                      type="radio"
                      id={option}
                      name="quizOption"
                      required="required"
                      value={option}
                      checked={selectedOption === option}
                      onChange={() => handleOptionChange(option)}
                    />
                    <label htmlFor={option}>{option}</label>
                  </div>
                )
              )}
            </form>
            <button onClick={handleAnswerClick} disabled={!selectedOption} className="pretest_next">
              <h3>
                Next
              </h3> 
            </button>
          </div>
        )}

        {quizCompleted && (
          <div>
            <p>Assessment completed!</p>
            <p>{`Overall Score: ${overallScore} points (${overallPercentage}%)`}</p>
            {Object.keys(scores).map((topic) => (
              <p key={topic}>{`${
                topic.charAt(0).toUpperCase() + topic.slice(1)
              }: ${scores[topic]} correct answers out of ${
                questions[topic].length
              } questions (${(
                (scores[topic] / questions[topic].length) *
                100
              ).toFixed(2)}%)`}</p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PosttestModal;
